import type { MarketingStep } from '@/config/marketing-content/types'
import { SectionHeader } from '@/components/marketing/section-header'
import { cn } from '@/lib/utils'

export function HowItWorksSteps({
  kicker,
  title,
  lead,
  steps,
  className,
}: {
  kicker?: string
  title: string
  lead?: string
  steps: MarketingStep[]
  className?: string
}) {
  return (
    <section className={cn('marketing-section', className)}>
      <div className="marketing-container how-it-works-steps">
        <SectionHeader eyebrow={kicker} title={title} lead={lead} align="center" />
        <div className="how-it-works-steps__grid">
          {steps.map((step) => (
            <article key={step.title} className="how-it-works-steps__card">
              <h3 className="how-it-works-steps__title">{step.title}</h3>
              <p className="how-it-works-steps__description">{step.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
